import useProviderRecordEditable from "../../../../../../../../../../hooks/useProviderRecordEditable";
import ValueWithFallback from "../../../../../../../../../global/ValueWithFallback";
import CustomTextField from "../../../components/CustomTextField";
import { TEXTFIELD_TYPES } from "../../../components/CustomTextFieldTypes";
import FieldInfo from "../../../components/FieldInfo";
import getUpdatedString from "../../../components/utils/getUpdatedString";
import { useProCliStore } from "../../../hooks/useProCliStore";
import getHistoryEntryWithFallback from "../utils/getHistoryEntryWithFallback";

export default function Balances({
  currentAccordionItem,
  activateButtons,
  deactivateButtons,
  providerHistory,
}) {
  const index = currentAccordionItem.index;
  const proCliData = currentAccordionItem.proCliData;
  const canEditRecord = useProviderRecordEditable(proCliData);
  const { setProvidersData } = useProCliStore();
  const confirmedBalanceHistory = getHistoryEntryWithFallback(
    providerHistory?.currentBalance,
    proCliData
  );
  const runningTotalHistory = getHistoryEntryWithFallback(
    providerHistory?.runningTotal,
    proCliData
  );

  const updateProviderInfo = (updatedData = null) => {
    if (updatedData === null) {
      deactivateButtons();
      return;
    }
    if (updatedData.get(index).editableFields === null) {
      deactivateButtons();
    } else {
      activateButtons();
    }
    if (updatedData !== null) {
      setProvidersData(updatedData);
    }
  };
  return (
    <div id="Provider-Balances" data-testid="Provider-Balances">
      <div className="mt-4 flex w-full flex-row flex-wrap items-start justify-start">
        <div className="w-1/2">
          <div className="h-3/4">
            <CustomTextField
              index={index}
              title={"Verbal Balance"}
              fieldName={"currentBalance"}
              subTitle={""}
              width={"w-6/6"}
              disabled={!canEditRecord}
              defaultValue={ValueWithFallback(proCliData?.currentBalance, "")}
              placeholder={"0.00"}
              providerInfo={proCliData}
              type={TEXTFIELD_TYPES.CURRENCY}
              activateButtons={activateButtons}
              deactivateButtons={deactivateButtons}
              updateProviderInfo={updateProviderInfo}
            />
          </div>
          <div className="h-[20%]">
            {confirmedBalanceHistory && (
              <FieldInfo
                title={"Updated"}
                value={getUpdatedString(
                  confirmedBalanceHistory.user,
                  confirmedBalanceHistory.timestamp
                )}
              />
            )}
          </div>
        </div>
        <div className="w-1/2">
          <div className="h-1/4">
            <CustomTextField
              index={index}
              title={"Received Bill Charges"}
              subTitle={""}
              width={"w-6/6"}
              disabled={true}
              defaultValue={ValueWithFallback(proCliData?.runningTotal, "0.00")}
              providerInfo={proCliData}
              type={TEXTFIELD_TYPES.CURRENCY}
              activateButtons={activateButtons}
              deactivateButtons={deactivateButtons}
              updateProviderInfo={updateProviderInfo}
            />
          </div>
          <div className="h-[20%]">
            {runningTotalHistory && (
              <FieldInfo
                title={"Updated"}
                value={getUpdatedString(runningTotalHistory.user, runningTotalHistory.timestamp)}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
